import { App, Space } from "antd";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { empleadoSetActive, empleadoStartDelete } from "../../../actions";
import { ShowDeleteConfirm } from "../../../helpers/confirmModal";
import { ButtonUi } from "../../ui/ButtonUi";
import {
  DateFormats,
  TipoButtonConstants,
} from "../../../types/typesConstants";
import dayjs from "dayjs";
import { TableSearchBasicUi } from "./../../ui/TableSearchBasicUi";
import { ContactoPersonaColumn, NroDocumentoColumn } from "../../ui";

const columns = ({ filteredColumn, handleEditar, handleEliminar }) => [
  {
    title: "N°",
    dataIndex: "index",
    key: "index",
    render: (text, record, index) => <>{index + 1}</>,
  },
  {
    title: "Nombre",
    dataIndex: ["persona", "nombrecompleto"],
    key: "nombrecompleto",
    filteredValue: [filteredColumn],
    onFilter: (value, record) =>
      String(record?.persona?.nombrecompleto)
        .toLowerCase()
        .includes(value.toLowerCase()) ||
      String(record?.persona?.nrodocumento)
        .toLowerCase()
        .includes(value.toLowerCase()) ||
      String(record?.persona?.direccion)
        .toLowerCase()
        .includes(value.toLowerCase()),
  },

  {
    title: "N° Documento",
    dataIndex: ["persona", "nombretipodocumento"],
    key: "nombretipodocumento",
    align: "center",
    render: (text, record) => (
      <NroDocumentoColumn
        nrodocumento={record?.persona?.nrodocumento}
        tipodocumento_nombre={record?.persona?.nombretipodocumento}
      />
    ),
  },
  {
    title: "Fec.Nacimiento",
    dataIndex: ["persona", "fechanacimiento"],
    key: "fechanacimiento",
    render: (text, record, index) => (
      <>{dayjs(text).format(DateFormats.frontend)}</>
    ),
  },
  {
    title: "Contacto",
    dataIndex: ["persona", "email"],
    key: "email",
    align: "center",
    render: (text, record) => (
      <ContactoPersonaColumn
        telefono={record?.persona?.telefono}
        email={record?.persona?.email}
        website={record?.persona?.website}
      />
    ),
  },
  {
    title: "Dirección",
    dataIndex: ["persona", "direccion"],
    key: "direccion",
  },
  {
    title: "Acciones",
    dataIndex: "acciones",
    key: "acciones",
    render: (text, record) => (
      <Space size="middle">
        <ButtonUi
          typeUi={TipoButtonConstants.EditarTable}
          displayText={false}
          htmlType="button"
          onClick={() => handleEditar(record)}
        />
        <ButtonUi
          typeUi={TipoButtonConstants.EliminarTable}
          displayText={false}
          onClick={() => handleEliminar(record)}
        />
      </Space>
    ),
  },
];
export const EmpleadoTable = ({ data, loading, handleOpenForm }) => {
  const { modal } = App.useApp();
  const dispatch = useDispatch();
  const [searchText, setSearchText] = useState("");
  const handleEditar = (data) => {
    dispatch(empleadoSetActive(data));
    handleOpenForm();
  };
  const handleEliminar = (item) => {
    ShowDeleteConfirm({
      modal,
      title: "¿Está seguro de eliminar el empleado seleccionado?",
      content: item?.persona?.nombrecompleto,
      callback: (isConfirmed) => {
        if (isConfirmed) {
          dispatch(empleadoStartDelete(item));
        }
      },
    });
  };
  const onSearch = (value) => {
    setSearchText(value);
  };
  return (
    <TableSearchBasicUi
      columns={columns({
        filteredColumn: searchText,
        handleEditar,
        handleEliminar,
      })}
      rowKey="id"
      bordered
      data={data}
      onSearch={onSearch}
      loading={loading}
      size="small"
    />
  );
};
